import {TBaseOrObservableType} from "../../index";
import {getAnyValue} from "../../util/misc";

export namespace nsModal {
    export function formatTitle(title: TBaseOrObservableType<string>) {
        const _t = getAnyValue(title);
        return _t?.replace(/\[.*\]/gm, (match: string) => {
            return `<span class="name">${match}</span>`;
        }) ?? 'N/A';

    }
}